import { Route, Routes } from "react-router-dom";

import { DispersionsListPage } from "./pages/DispersionsListPage";

export const DispersionsNavigation = () => {
  return (
    <Routes>
      <Route path="/" element={<DispersionsListPage />} />
    </Routes>
  );
};
